<template>
  <div class="content-wrapper">
    <p v-if="title" class="small medium title">{{ title }}</p>
    <div class="content-slot">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: '',
  }
);
</script>

<style scoped lang="scss">
.content-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  gap: 0.325rem;
  margin-top: 1rem;
  align-items: center;
  align-self: stretch;
}

.title {
  display: flex;
  flex: 1;
  width: 100%;
  min-width: fit-content;
  margin-right: 1rem;
  font-weight: 400;
  @include respond-to(mobile-landscape) {
    margin-right: 0;
  }
}

.content-slot {
  display: flex;
  flex: 3;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  min-height: 2.5rem;
  justify-content: center;
}

@media (min-width: 768px) {
  .content-wrapper {
    flex-direction: unset;
  }

  .title {
    flex: 1;
    align-self: flex-start; // 수직 가운데 말고 맨 위 정렬
    margin-top: 0.8rem;
  }
}
</style>
